var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2519_43482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 5.83464C8.33398 5.39261 8.50958 4.96868 8.82214 4.65612C9.1347 4.34356 9.55862 4.16797 10.0007 4.16797H15.0006C15.4427 4.16797 15.8666 4.34356 16.1792 4.65612C16.4917 4.96868 16.6673 5.39261 16.6673 5.83464V14.168C16.6673 14.61 16.4917 15.0339 16.1792 15.3465C15.8666 15.659 15.4427 15.8346 15.0006 15.8346H10.0007C9.55862 15.8346 9.1347 15.659 8.82214 15.3465C8.50958 15.0339 8.33398 14.61 8.33398 14.168V5.83464Z",
    stroke: "#38BFF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 5.83203V14.1654",
    stroke: "#38BFF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 6.66797V13.3346",
    stroke: "#38BFF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2519_43482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.2ca896c6c5480f3be4c79c6470afac66.svg";
export { ForwardRef as ReactComponent };